import { useState, useCallback } from 'react';

import type { DropdownState } from './types';

const useDropdownState = () => {
  const [dropdownState, setDropdownState] = useState<DropdownState>({
    menu: false,
    help: false,
    addActions: false,
  });

  const toggleDropdown = useCallback((dropdown: keyof DropdownState) => {
    setDropdownState(prev => ({
      ...prev,
      [dropdown]: !prev[dropdown],
    }));
  }, []);

  const closeDropdown = useCallback((dropdown: keyof DropdownState) => {
    setDropdownState(prev => ({
      ...prev,
      [dropdown]: false,
    }));
  }, []);

  return {
    dropdownState,
    toggleDropdown,
    closeDropdown,
  };
};

export default useDropdownState;
